var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrophy = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 25H10.0001M22.0001 25C23.0609 25 24.0783 25.4214 24.8285 26.1716C25.5786 26.9217 26.0001 27.9391 26.0001 29H6.00006C6.00006 27.9391 6.42149 26.9217 7.17163 26.1716C7.92178 25.4214 8.93919 25 10.0001 25M22.0001 25V20.5C22.0001 19.672 21.3294 19 20.5001 19H19.3387M10.0001 25V20.5C10.0001 19.672 10.6721 19 11.5001 19H12.6627M19.3387 19H12.6627M19.3387 19C18.5898 17.7066 18.1423 16.261 18.0294 14.7707M12.6627 19C13.4112 17.7065 13.8582 16.2609 13.9707 14.7707M7.00006 5.648C5.69073 5.83867 4.39473 6.07067 3.11206 6.34133C3.40939 8.08638 4.27683 9.68364 5.57865 10.8832C6.88047 12.0827 8.54322 12.8168 10.3067 12.9707M7.00006 5.648V6C7.00006 8.81067 8.28806 11.32 10.3067 12.9707M7.00006 5.648V3.628C9.94139 3.21333 12.9467 3 16.0001 3C19.0547 3 22.0601 3.21333 25.0001 3.62667V5.648M10.3067 12.9707C11.3734 13.8444 12.6273 14.4603 13.9707 14.7707M25.0001 5.648V6C25.0001 8.81067 23.7121 11.32 21.6934 12.9707M25.0001 5.648C26.3031 5.8376 27.5998 6.06883 28.8881 6.34133C28.5908 8.08618 27.7235 9.68328 26.422 10.8828C25.1204 12.0823 23.458 12.8165 21.6947 12.9707M21.6947 12.9707C20.6276 13.8445 19.3733 14.4605 18.0294 14.7707M18.0294 14.7707C16.694 15.0787 15.3061 15.0787 13.9707 14.7707",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrophy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/trophy.37343920863f1438bc5d8f6dd117d259.svg";